module.exports = __webpack_public_path__ + "media/images/lp/lp24-4ed12683892e5ccbd5dfc985a624b52a.webp";